import { Report, Check } from '@material-ui/icons';
import { CircularProgress } from '@material-ui/core';

const StatusDisplay = (props) => {
  const { status, style } = props
  console.log(`Status Display :: ${status}`);
  if (status === 'loading') {
   return (
    <div style={style}>
      <CircularProgress color="inherit" size={28} thickness={4} />
    </div>
   )
  }
  else if (status === 'failure') {
    return (
      <div style={style}>
        <Report color="inherit" />
      </div>
    )
  }
  else if (status === 'success') {
    return (
      <div style={style}>
        <Check color="inherit" />
      </div>
    ) 
  }
  else {
    return <div style={style}>something went wrong</div>
  }
}

export default StatusDisplay